(function () {
  'use strict';
  // TEMP PERFORMANCE TEST: disable the delayed localized-description runtime.
  // This removes its repeated 0/80/250/700/1500/3000/5000/8000 ms rescans
  // and its document-wide MutationObserver while we isolate the remaining flash.
  window.__starlessLocalizedDescriptionAccordionsLoaded = true;
})();
